import React from 'react';
import { useSelector } from 'react-redux';

import StyledField from './StyledField';

import Player from 'components/Player';

import { selectHomeTeam, selectAwayTeam } from 'features/match/matchSlice';
import { FormattedMessage } from 'react-intl';
import Substitute from '../Player/Substitute';
import { defaultKit } from '../../constants/styles';

const Field: React.FC = () => {
  const homeTeam = useSelector(selectHomeTeam);
  const awayTeam = useSelector(selectAwayTeam);

  const homeTeamKit = !homeTeam.kit ? defaultKit : homeTeam.kit;

  const homePlayerElements = homeTeam.persons
    .filter((person) => person.startsMatch)
    .map((person) => <Player key={person.personId} player={person} kit={homeTeamKit} />);
  const homeSubstituteElements = homeTeam.persons
    .filter((person) => {
      return (
        !person.startsMatch && (person.entersFieldMinute || person.entersFieldMinute === 0) && !person.leavesFieldMinute
      );
    })
    .map((person) => <Substitute key={person.personId} player={person} kit={homeTeamKit} />);

  const awayTeamKit = !awayTeam.kit ? defaultKit : awayTeam.kit;

  const awayPlayerElements = awayTeam.persons
    .filter((person) => person.startsMatch)
    .map((person) => <Player key={person.personId} player={person} kit={awayTeamKit} away={true} />);
  const awaySubstituteElements = awayTeam.persons
    .filter((person) => {
      return (
        !person.startsMatch && (person.entersFieldMinute || person.entersFieldMinute === 0) && !person.leavesFieldMinute
      );
    })
    .map((person) => <Substitute key={person.personId} player={person} kit={awayTeamKit} />);

  return (
    <StyledField>
      {homeSubstituteElements.length > 0 && (
        <div className="substitutedOn">
          <div>
            <FormattedMessage id="field.substitutes" />
          </div>
          <div className="substitutesHomeTeam substitutes">{homeSubstituteElements}</div>
        </div>
      )}
      <div className="field">
        <div className="home">{homePlayerElements}</div>
        <div className="away">{awayPlayerElements}</div>
      </div>
      {awaySubstituteElements.length > 0 && (
        <div className="substitutedOn">
          <div>
            <FormattedMessage id="field.substitutes" />
          </div>
          <div className="substitutesAwayTeam substitutes">{awaySubstituteElements}</div>
        </div>
      )}
    </StyledField>
  );
};

export default Field;
